import { ACTION_TYPE } from './action';

const entry = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.CALL_API_INIT_SELECT_VALUES_SUCCESS:
      return {
        ...state,
        initSelectValues: action.initSelectValues,
      };
    case ACTION_TYPE.SET_MEMBER_ENTRY_FORM:
      return {
        ...state,
        memberEntry: action.memberEntry,
      };
    case ACTION_TYPE.GET_ZIP_CODE_ADDRESS_SUCCESS:
      return {
        ...state,
        zipcode: action.zipcode,
      };
    case ACTION_TYPE.GET_ZIP_CODE_ADDRESS_USER_SUCCESS:
      return {
        ...state,
        zipcodeUser: action.zipcode,
      };
    case ACTION_TYPE.CALL_API_SAVE_ENTRY_SUCCESS:
      return {
        ...state,
        isSaveSuccess: true,
        saveMembers: action.saveMembers,
      };
    case ACTION_TYPE.RESET_MEMBER_ENTRY_FLG:
      return {
        ...state,
        isSaveSuccess: false,
      };
    default:
      return state;
  }
};

export default entry;
